import { DataState } from 'types/store/reducers/dataSources';

import { normalizeById } from 'store/utils';
import { Staff } from 'types';
import { StaffActions } from 'types/store/actions/staff';
import { StaffActionTypes } from 'types/store/actions/constants';

export const initialState: DataState<Staff> = {
  data: {},
};

export default (
  state = initialState,
  action: StaffActions
): DataState<Staff> => {
  switch (action.type) {
    case StaffActionTypes.RESET:
      return initialState;

    case StaffActionTypes.LIST_ALL_SUCCESS:
    case StaffActionTypes.LIST_SUCCESS: {
      const { records } = action.payload;
      const normalizedStaff = normalizeById(records);
      return {
        ...state,
        data: { ...state.data, ...normalizedStaff },
      };
    }
    default:
      return state;
  }
};
